import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { validationmethod } from 'src/app/shared/Validations/Validationmethods';
import { LifeCyclePopUpComponent } from './life-cycle-pop-up/life-cycle-pop-up.component';
import { LifecycleService } from 'src/app/shared/services/lifecycle.service';
import { JSIGNALBUTTON } from 'src/app/shared/common/JsignalButtons';

@Component({
    selector: 'app-life-cycle',
    templateUrl: './life-cycle.component.html',
    styleUrls: ['./life-cycle.component.scss'],
    standalone: false
})
export class LifeCycleComponent implements OnInit {
  validation_messages
// columnDefs;
rowClassRules;
defaultColDef;
rowSelectionForTablesFields;
rowSelection;

paginationPageSize;

paginationNumberFormatter;

lastpage;

currentpage;

nextpage;

nextpageplusone;

totalpages;

buttonIdList: any = [];
pagesize;
components: any;
gridApi;
  backgroundColorScreen: any;
  buttonColor: any;
  rowData: any[] = [
    // { id: 1, name: "Item 1", status: "Yes" },
    // { id: 2, name: "Item 2", status: "No" },
    // { id: 3, name: "Item 3", status: "Yes" },
  ];
  columnDefs = [
    { headerName: "Action", field: "action", sortable: true, filter: true,width: 100 },
    { headerName: "State Name", field: "statename", sortable: true, filter: true,width: 200 },
    { headerName: "State Type", field: "statetype", sortable: true, filter: true,width: 150 }
  ];
  buttonName
  lifecycleStatesrequestDto = {
    statename: "",
    statetype:""
  }
  lifecycleRequestDto = {
  lifecyclename: "",
    description: "",
    object: "",
    states: [] as any[]
  }
  objects = [
    { value: "Object1", viewValue: "Object 1" },
    { value: "Object2", viewValue: "Object 2" },
    { value: "Object3", viewValue: "Object 3" }
  ];
   validations_form: UntypedFormGroup;
  formValid: UntypedFormGroup;
  getRowStyle: (params: any) => { backgroundColor: string; };
  columnDefinitionsForLifecycle = []
  frameworkcomponent;
  getData: any;
  constructor(private localStorageSettings: LocalStorageSettingsService, private validation: validationmethod,
    private spinner: NgxUiLoaderService, private snackbar: MatSnackBar,private dialog:MatDialog, private lifecycleservice: LifecycleService
  ) {
    this.components = {
      buttonRenderer: JSIGNALBUTTON
    }
  }
  /**
     * @Author Shyam 
     * @Date 05/03/2026
     *  @Description: Lifecycle Component
     */
  ngOnInit(): void {
    this.buttonName = 'Save'
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      resizable: true,
      filter: true,
      sortable: true,
    }
    this.columnDefinitionsForLifecycle = [{
       headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
    { headerName: 'Lifecycle Name', headerTooltip: 'Lifecycle Name', tooltipValueGetter: (params) => 'Lifecycle Name : ' + params.value, field: 'lifecyclename', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Description', headerTooltip: 'Description', tooltipValueGetter: (params) => 'Description : ' + params.value, field: 'description', filter: 'agTextColumnFilter', width: 250 },
    // { headerName: 'Object', headerTooltip: 'Object', tooltipValueGetter: (params) => 'Object : ' + params.value, field: 'objectname', filter: 'agTextColumnFilter', width: 350 },  
      { headerName: 'Default Lifecycle', headerTooltip: 'Default Lifecycle', tooltipValueGetter: (params) => 'Default Lifecycle : ' + params.value, field: 'defualtlifecycle', filter: 'agTextColumnFilter', width: 250 },
      // { headerName: 'States', headerTooltip: 'States', tooltipValueGetter: (params) => 'States : ' + params.value, field: 'states', filter: 'agTextColumnFilter', width: 350 },
     {headerName: "States",headerTooltip: "States",field: "states",cellRenderer: (params) => {return params.value?.map(s => s.statename).join(", ");}, tooltipValueGetter: (params) => {return params.value?.map(s => s.statename).join(", ");}, filter: 'agTextColumnFilter', width: 250 },
      {
        headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 350,
        cellStyle: (params) => {
          if (params.value == 'Yes'){
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        },
      }
      
    ]
    this.formValidation();
    this.formValidationforState();
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

  }
  formValidation() {
    this.validations_form = new UntypedFormGroup({
      lifecyclename: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator]),
      description: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator]),
      object: new FormControl(''),
    });
  }
  formValidationforState() {
    this.formValid = new UntypedFormGroup({
      statename: new FormControl('',),
      statetype: new FormControl('', ),
    });
  } 

  
  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }
  onGridReady(params){
    this.gridApi = params;
    params.api.setGridOption('rowData', [])
    
    var tenantId = localStorage.getItem('dnsName');
    console.log(tenantId)
    this.lifecycleservice.getLifecycleDetails().subscribe((response) => { 
      console.log(response)
      if(response.error == true){
        this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
        this.getData = null;
        this.gridApi.api.setGridOption('rowData', this.getData);
      } else {
        console.log(response)
       this.getData = response;
      this.gridApi.api.setGridOption('rowData', this.getData);
      }
      
    } )  
     
  }
  onGridReadyForLifecycle(params: any) {
     this.gridApi = params;
    params.api.setGridOption('rowData', [])
    
    var tenantId = localStorage.getItem('dnsName');
     console.log(tenantId)
  }

 

  editIcon(params) { 
    console.log(params.rowData)
     this.buttonName = 'Update'
    const dialogRef = this.dialog.open(LifeCyclePopUpComponent, {
     width: "70%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "85%",
      disableClose: true,
        data:{edata:params.rowData,buttonName:this.buttonName}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed',result);
      this.onGridReady(this.gridApi);
    });

  }

  deleteIcon(params) {
    console.log(params.rowData)
    if(params.rowData.status == "No"){
      this.snackbar.open("Lifecycle is already deleted", 'OK', { duration: 3000 });
      return;
    }
    if (confirm("Are you sure you want to delete this record?")) {
      this.spinner.start();
      this.lifecycleservice.deleteLifecycle(params.rowData.lifecycleid).subscribe((response) => {
        console.log(response)
        this.spinner.stop();
        if (response.error == true) {
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
        } else {
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          this.onGridReady(this.gridApi);
        }
       
      })
    } 
  }

  openSaveForm(params) {
    this.buttonName = 'Save'
    const dialogRef = this.dialog.open(LifeCyclePopUpComponent, {
     width: "70%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "85%",
        disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.onGridReady(this.gridApi);
    });
  }
}
